import Parser from 'web-tree-sitter'

let NQL = null

async function initialize() {
  await Parser.init()
  NQL = await Parser.Language.load('/js/tree-sitter-nql.wasm')
}

export async function getNQLParser() {
  if (NQL === null) {
    await initialize()
  }
  const parser = new Parser()
  parser.setLanguage(NQL)
  return parser
}

window.getNQLParser = getNQLParser
